<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 21 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [style.opacity]="opacity"
>
  <defs>
    <linearGradient
      *ngIf="hasGradient"
      [attr.id]="gradientId"
      x1="0%"
      y1="0%"
      x2="100%"
      y2="100%"
    >
      <stop offset="0%" [attr.stop-color]="startColor" />
      <stop offset="100%" [attr.stop-color]="endColor" />
    </linearGradient>
  </defs>
  <path
    d="M1 18.6C0.716667 18.6 0.479333 18.504 0.288 18.312C0.0966668 18.12 0.000666667 17.8827 0 17.6V11.6C0 11.3167 0.0960001 11.0793 0.288 10.888C0.48 10.6967 0.717333 10.6007 1 10.6H7C7.28333 10.6 7.521 10.696 7.713 10.888C7.905 11.08 8.00067 11.3173 8 11.6V17.6C8 17.8833 7.904 18.121 7.712 18.313C7.52 18.505 7.28267 18.6007 7 18.6H1ZM12.725 8.1H5.275C4.89167 8.1 4.60433 7.929 4.413 7.587C4.22167 7.245 4.22567 6.90767 4.425 6.575L8.15 0.5C8.35 0.166667 8.63333 0 9 0C9.36667 0 9.65 0.166667 9.85 0.5L13.575 6.575C13.775 6.90833 13.7793 7.246 13.588 7.588C13.3967 7.93 13.109 8.10067 12.725 8.1ZM18.875 20.35L16.925 18.4C16.575 18.6333 16.196 18.8083 15.788 18.925C15.38 19.0417 14.9507 19.1 14.5 19.1C13.25 19.1 12.1877 18.6627 11.313 17.788C10.4383 16.9133 10.0007 15.8507 10 14.6C9.99933 13.3493 10.437 12.287 11.313 11.413C12.189 10.539 13.2513 10.1013 14.5 10.1C15.7487 10.0987 16.8113 10.5363 17.688 11.413C18.5647 12.2897 19.002 13.352 19 14.6C19 15.0333 18.9417 15.4543 18.825 15.863C18.7083 16.2717 18.5417 16.6507 18.325 17L20.275 18.95C20.4583 19.1333 20.55 19.3667 20.55 19.65C20.55 19.9333 20.4583 20.1667 20.275 20.35C20.0917 20.5333 19.8583 20.625 19.575 20.625C19.2917 20.625 19.0583 20.5333 18.875 20.35ZM16.275 16.375C16.7583 15.8917 17 15.3 17 14.6C17 13.9 16.7583 13.3083 16.275 12.825C15.7917 12.3417 15.2 12.1 14.5 12.1C13.8 12.1 13.2083 12.3417 12.725 12.825C12.2417 13.3083 12 13.9 12 14.6C12 15.3 12.2417 15.8917 12.725 16.375C13.2083 16.8583 13.8 17.1 14.5 17.1C15.2 17.1 15.7917 16.8583 16.275 16.375Z"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
  ></path>
</svg>
